import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { EventsPage } from '@/pages/events'

export const Route = createFileRoute('/_authenticated/events/')({
  validateSearch: z.object({ inbox: z.string().optional() }),
  component: EventsRoute,
})

function EventsRoute() {
  const { inbox } = Route.useSearch()
  return <EventsPage key={inbox ?? 'all'} inboxId={inbox} />
}

// Note: This is an INDEX route (events.index.tsx), not a layout route.
// This means /events shows the list, and /events/$eventId is a SIBLING route
// that completely replaces this view (not a child that needs an Outlet).
